import { fg } from '@atlassian/jira-feature-gating';
import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue, RichValue } from '../../../value/types.tsx';
import type {
	TransformedPriority,
	TransformedPriorityField,
	TransformedOldPriorityField,
} from '../types.tsx';

const isNewTransformedPriorityField = (
	field: TransformedPriorityField | TransformedOldPriorityField,
): field is TransformedPriorityField =>
	typeof field.value === 'object' && 'name' in (field.value || {});

const isOldTransformedPriorityField = (
	field: TransformedPriorityField | TransformedOldPriorityField,
): field is TransformedOldPriorityField => typeof field.value === 'string';

const getPriorityValueOld: StringValue<TransformedPriorityField> = (field) =>
	field.value?.name || '';

const getPriorityValue: StringValue<TransformedPriorityField | TransformedOldPriorityField> = (
	field,
) => {
	if (fg('list_view_small_bulk_copy_fixes')) {
		if (isNewTransformedPriorityField(field)) {
			return field.value?.name || '';
		}
		if (isOldTransformedPriorityField(field)) {
			return field.value;
		}
		return '';
	}

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return getPriorityValueOld(field as TransformedPriorityField);
};

export const priorityStringValueHandler = {
	[PRIORITY_TYPE]: getPriorityValue,
};

const getPriorityRichValue: RichValue<TransformedPriorityField, TransformedPriority> = (field) =>
	field.value || null;

export const priorityRichValueHandler = {
	[PRIORITY_TYPE]: getPriorityRichValue,
};
